import { logEvent } from "firebase/analytics";
import React from "react";
import DiscordIcon from "../../images/Svg/DiscordIcon.svg";
import { analytics } from "../../utils/firebase";

const JoinCommunity = ({ title, description, name }) => {
  const handleDiscord = () => {
    logEvent(analytics, name);
    window.open("https://discord.gg/M9njr5cBBT", "_blank");
  };
  return (
    <section
      className={`container  mx-auto px-4 sm:px-4 md:px-16 joinCommuntiy text-center`}
    >
      <h1
        className={`text-[#161616] Secondheading title font-bold text-center`}
      >
        {title}
      </h1>
      <p className="w-3/4 mx-auto text-[#161616] mt-8">{description}</p>
      <div onClick={handleDiscord}>
        <div className="button_hover">
          <div className="bg-blue p-6 rounded-[8px] cursor-pointor w-[249px] h-[56px] mt-6 mx-auto flex items-center text-white justify-center">
            <img src={DiscordIcon} alt="" />
            <p className="text-[16px] mx-3"> Join Discord</p>{" "}
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinCommunity;
